import { Link } from 'react-router'
import { Text } from '@carouselgg/nexus/text'
import { Container } from '@carouselgg/nexus/container'
import { DiscordLogo } from '@carouselgg/nexus/icon'
import { DISCORD_INVITE } from '../constants/links'
import styles from './AppFooter.module.css'

interface AppFooterProps {
  collapsed?: boolean
}

export function AppFooter({ collapsed }: AppFooterProps) {
  return (
    <footer className={`${styles.footer} ${collapsed ? styles.footerCollapsed : ''}`}>
      <Container size="lg">
        <div className={styles.footerContent}>
          <Text size="xs" muted>
            &copy; {new Date().getFullYear()}{' '}
            <Link to="/" className={styles.homeLink}>Carousel</Link>. All rights reserved.
          </Text>
          <div className={styles.footerLinks}>
            <a href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <DiscordLogo size={12} /> Discord
            </a>
            <Link to="/privacy" className={styles.footerLink}>Privacy</Link>
            <Link to="/terms" className={styles.footerLink}>Terms</Link>
          </div>
        </div>
      </Container>
    </footer>
  )
}
